module.exports = __webpack_public_path__ + "img/recovery-passwordUA.0699f25e.png";